/**
 * exp/image-slider — autoplay image Swiper (scoped per block instance).
 */
import Swiper from 'swiper';
import { Autoplay, Navigation } from 'swiper/modules';

import 'swiper/css';

const roots = document.querySelectorAll('.exp-image-slider');

roots.forEach((root) => {
	const el = root.querySelector('.swiper-container-image-slider');

	if (!el) {
		return;
	}

	const slideCount = el.querySelectorAll('.swiper-wrapper > .swiper-slide').length;

	if (slideCount < 2) {
		return;
	}

	const prevEl = root.querySelector('.swiper-button-prev');
	const nextEl = root.querySelector('.swiper-button-next');

	// eslint-disable-next-line no-new
	new Swiper(el, {
		modules: [Autoplay, Navigation],
		slidesPerView: 1,
		loop: true,
		autoplay: {
			delay: 5000,
			disableOnInteraction: false,
		},
		navigation: {
			prevEl: prevEl || null,
			nextEl: nextEl || null,
		},
	});
});
